export const customSort = (a: number | string, b: number | string): number => {
  if (a === b) {
    return 0;
  }
  const aInt = a.toString().split('.').join('');
  const bInt = b.toString().split('.').join('');
  return aInt.localeCompare(bInt);
};
